// ------------------------------------------------------------
// Layout grid spacing helpers
// ------------------------------------------------------------

export const GRID_SIZE_PRESETS = [10, 20, 50, 100] as const;
export const GRID_SIZE_MIN = 5;
export const GRID_SIZE_MAX = 500;
export const DEFAULT_GRID_SIZE = 20;

export function effectiveGridSize(
  settings?: { grid_size?: number } | null,
): number {
  const raw = settings?.grid_size;
  if (raw != null && raw > 0) return raw;
  return DEFAULT_GRID_SIZE;
}

export function clampGridSize(size: number): number {
  return Math.min(
    GRID_SIZE_MAX,
    Math.max(GRID_SIZE_MIN, Math.round(size)),
  );
}
